import { render } from "./DropdownItemCustom.vue?vue&type=template&id=710471cc"
import script from "./DropdownItemCustom.vue?vue&type=script&lang=js"
export * from "./DropdownItemCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__